/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Dull_Kudu_GleamInputs */

const fr_bold_dull_kudu_gleam = /** @type {(inputs: Bold_Dull_Kudu_GleamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`au`)
};

/**

* @param {Bold_Dull_Kudu_GleamInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bold_dull_kudu_gleam = /** @type {((inputs?: Bold_Dull_Kudu_GleamInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Dull_Kudu_GleamInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bold_dull_kudu_gleam(inputs)
});